 
<template>
  <div class="discover-page page">
    
    <div class="block_1">
      <section class="section_1">
        <van-nav-bar
          title="发现"
          left-arrow
          @click-left="onClickLeft" 
          @click-right="onClickRight"
        />
      </section>

      <section class="section_2">
        <van-list
          class="list_1"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="image-text_1"
            v-for="item in list"
            :key="item.id || item.article_id"
            @click="handleItemClick(item)"
          >
            <video
              v-if="item.type === 'video'"
              class="group_1 video-thumb"
              :src="item.video_url"
              :poster="item.img"
              muted
              playsinline
              webkit-playsinline
              preload="metadata"
            ></video>
            <img v-else class="group_1" :src="item.img" alt="" />
            <div class="text-group_1">
              <div class="text_3">{{ item.title }}</div>
              <div class="text_4">
                {{ item.content || item.remark || "敬请期待" }}
              </div>
            </div>
          </div>
        </van-list>
      </section>
    </div>

    <!-- <div class="block_4"></div> -->
    <van-overlay
      :show="showVideoPlayer"
      class="video-overlay"
      :lock-scroll="true"
      @click="closeVideoPlayer"
    >
      <div class="video-wrapper" @click.stop>
        <video
          ref="fullscreenVideo"
          class="fullscreen-video"
          :src="currentVideoUrl"
          controls
          autoplay
          playsinline
          webkit-playsinline
        ></video>
        <button class="video-close-btn" @click="closeVideoPlayer">
          &times;
        </button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import checkDevice from "../../tools/app";
import qs from "qs";

// 提前在模块加载阶段兜底定义全局 callJsFunction，避免“未定义”报错
if (typeof window !== "undefined") {
  if (typeof window.callJsFunction !== "function") {
    window.callJsFunction = function (str) {
      // 如果发现页组件已经把处理函数挂上来，就转发给它
      if (
        window.__discoverCallJsHandler__ &&
        typeof window.__discoverCallJsHandler__ === "function"
      ) {
        window.__discoverCallJsHandler__(str);
      } else {
        // 组件还没就绪时，先把参数暂存，等组件 created 再消费
        window.__pendingCallJsArgs__ = str;
      }
    };
  }
}

export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      showVideoPlayer: false,
      currentVideoUrl: "",
      Itoken: "",
      // exclusive: "XY1000001292399539",
      exclusive: "",
    };
  },
  created() {
    // 用来让安卓和ios调用传递token和userId的方法 str接收
    // 把当前组件实例的处理函数注册到全局转发器上
    if (typeof window !== "undefined") {
      window.__discoverCallJsHandler__ = this.callJsFunction;
      // 如果在组件就绪前原生已经调用过一次，则在这里补一次执行
      if (window.__pendingCallJsArgs__) {
        this.callJsFunction(window.__pendingCallJsArgs__);
        delete window.__pendingCallJsArgs__;
      }
    }
    window["callJsFunction"] = this.callJsFunction;
    // 初始化加载接口数据
    this.getListData();
  },
  methods: {
    // 传过来token和userId的回调
    callJsFunction(str) {
      // 判断设备系统的函数
      let phone = checkDevice();
      this.Itoken = str;
      if (phone == "ios") {
        // sessionStorage.setItem("CONFIDENTIAL", str);
        this.exclusive = str.slice(37);
        // sessionStorage.setItem("EXCLUSIVE", exclusive);
      } else {
        // sessionStorage.setItem("CONFIDENTIAL", str);
        this.exclusive = str.slice(33);
        // sessionStorage.setItem("EXCLUSIVE", exclusive);
      }
    },
    // 从后台获取列表数据
    async getListData() {
      try {
        this.loading = true;
        const res = await this.$post({
          url: "/AppDiscovery/getList",
          method: "get",
        });

        if (res.retCode == 200) {
          const newItems = res.data.list || res.data || [];
          this.list = Array.isArray(newItems) ? newItems : [];
          this.finished = true;
        } else {
          this.$toast.fail(res.message || "加载失败");
          this.finished = true;
        }
      } catch (err) {
        console.error("获取列表数据失败:", err);
        this.$toast.fail("加载失败，请稍后重试");

        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    // 加载更多（滚动加载）
    onLoad() {
      if (!this.finished) {
        this.getListData();
      }
    },
    // 点击列表项跳转到详情页
    handleItemClick(item) {
      // 上报点击事件（无需阻塞跳转）
      this.reportClickEvent(item);
      if (item.type === "video") {
        this.playVideoFullScreen(item);
        return;
      }
      const articleId = item.article_id || item.id;
      this.$router.push({
        path: "/discoverClid",
        // 传递文章 ID 及序列化的完整 item，详情页可直接使用
        query: { articleId, item: encodeURIComponent(JSON.stringify(item)) },
      });
    },
    // 事件埋点：上报点击
    reportClickEvent(item) {
      // const articleId = item.id;
      // console.log(item)
      if (this.exclusive != "") {
        this.$post({
          url: `/event/report`,
          method: "post",
          data: qs.stringify({
            userId: this.exclusive,
            eventName: "p-clicked",
            bannerType: "discovery",
            bannerId: item.id,
          }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            loginToken: this.Itoken,
            // loginToken:'0f7a09938c85054c590537630f277348_XY1000001292399539'
          },
        }).catch((err) => {
          // 🔍 详细的错误调试信息
          const msg = (err && err.message) || err;
          const config = err && err.config;
          const base = config && config.baseURL;
          const url = config && config.url;
          const method = config && config.method;
          const status = err && err.response && err.response.status;
          const statusText = err && err.response && err.response.statusText;
          const responseData = err && err.response && err.response.data;

          console.error("❌ [DEBUG] event/report 请求失败:", {
            message: msg,
            status: status,
            statusText: statusText,
            baseURL: base,
            url: url,
            fullURL: (base || "") + url,
            method: method,
            requestData: config && config.data,
            responseData: responseData,
            error: err,
          });

          console.warn("event/report failed", msg, base, url);
        });
        console.log("成功了");
      } else {
        console.log("失败了");
        return;
      }
    },
    // 全屏播放视频
    playVideoFullScreen(item) {
      if (!item.video_url) {
        this.$toast("暂无可播放的视频");
        return;
      }
      this.currentVideoUrl = item.video_url;
      this.showVideoPlayer = true;
      this.$nextTick(() => {
        const videoEl = this.$refs.fullscreenVideo;
        if (videoEl) {
          videoEl.currentTime = 0;
          const playPromise = videoEl.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(() => {
              this.$toast("视频自动播放被阻止，请手动播放");
            });
          }
        }
      });
    },
    closeVideoPlayer() {
      const videoEl = this.$refs.fullscreenVideo;
      if (videoEl) {
        videoEl.pause();
      }
      this.showVideoPlayer = false;
      this.currentVideoUrl = "";
    },
    // 返回按钮：桥接调用原生 backHomePage
    onClickLeft() {
      const phone = checkDevice();

      if (phone === "ios") {
        // iOS：通过 WKWebView messageHandlers 调用原生
        if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.backHomePage
        ) {
          try {
            window.webkit.messageHandlers.backHomePage.postMessage({
              action: "backHomePage",
            });
            return;
          } catch (err) {
            console.error("调用 iOS backHomePage 失败：", err);
          }
        }
      } else if (phone === "android") {
        // Android：通过 jsCallAndroid 对象调用原生
        if (
          window.jsCallAndroid &&
          typeof window.jsCallAndroid.backHomePage === "function"
        ) {
          try {
            window.jsCallAndroid.backHomePage();
            return;
          } catch (err) {
            console.error("调用 Android backHomePage 失败：", err);
          }
        }
      }

      // 兜底逻辑（在浏览器中预览时使用）
      // this.$router.go(-1);
    },
    // 右侧按钮（如果有需要）
    onClickRight() {
      // 可以添加其他功能
    },
  },
};
</script>
<style lang="less" scoped>
.discover-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #f7f7f7;
  overscroll-behavior: none;
}

.page {
  position: relative;
  width: 100%;
  max-width: 375px;
  background-color: #f7f7f7;
  overflow: hidden;
}

.block_1 {
  width: 100%;
  background-color: #f7f7f7;
}

.section_1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
}

.section_2 {
  width: 100%;
  min-height: 725px;
  padding: 60px 0 20px;
  box-sizing: border-box;
}

.list_1 {
  width: calc(100% - 28px);
  margin: 0 auto;
  padding-bottom: 40px;
}

.image-text_1 {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-height: 103px;
  margin-bottom: 8px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  // transition: transform 0.15s ease, box-shadow 0.15s ease;

  // &:active {
  //   transform: scale(0.98);
  //   box-shadow: 0 1px 8px rgba(0, 0, 0, 0.18);
  // }
}

.group_1 {
  width: 135px;
  height: 93px;
  border-radius: 5px;
  object-fit: cover;
  margin: 5px;
  background-color: #d8d8d8;
}

.video-thumb {
  border: none;
  background: #000;
}

.text-group_1 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  margin-top: 15px;
  margin-left: 4px;
}

.text_3 {
  width: 100%;
  color: #000;
  font: 500 16px/22px PingFangSC-Medium, "Microsoft YaHei", sans-serif;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text_4 {
  width: 100%;
  color: #666;
  font: 14px/20px PingFangSC-Regular, "Microsoft YaHei", sans-serif;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.block_4 {
  width: 134px;
  height: 5px;
  margin: 20px auto;
  border-radius: 2px;
  background-color: #000;
  opacity: 0.08;
}

/deep/ .van-nav-bar {
  width: 100%;
  background: transparent;
}

/deep/ .van-nav-bar__title {
  font-weight: 600;
  font-size: 17px;
}

/deep/ .van-nav-bar .van-icon {
  color: #333;
  font-size: 18px;
}

.video-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2000;
}

.video-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #000;
}

.fullscreen-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.video-close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 24px;
  line-height: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
}
</style>

